// src/config/menuItems.js
export const menuItems = [
  { label: "Dashboard", path: "/dashboard", roles: ["user", "admin"] },
  { label: "Admin Panel", path: "/admin", roles: ["admin"] },
  { label: "Medical History", path: "/history", roles: ["user"] },
  { label: "Patients", path: "/patients", roles: ["user"] },
  { label: "Inventory", path: "/inventory", roles: ["user"] },
  { label: "Maintenance", path: "/maintenance", roles: ["user"] },
  { label: "Settings", path: "/settings", roles: ["user"] },
];
